<template>
  <div class="block text-primary-400 text-sm mt-2">
    <slot />
  </div>
</template>
